import { SCENE_LIST } from '../index.js';
import SceneCard from './SceneCard';
export default {
  name: 'scene',
  components: {
    SceneCard
  },
  data() {
    return {
      sceneList: SCENE_LIST
    };
  }
};